import { Component, OnInit } from '@angular/core';
import { ModalService } from '@avla/ui-design';

@Component({
  selector: 'app-modal-terms-conditions',
  templateUrl: './modal-terms-conditions.component.html',
  styleUrls: ['./modal-terms-conditions.component.scss']
})
export class ModalTermsConditionsComponent implements OnInit {

  public modalName: string = 'modal-terms-conditions';

  constructor(private modalService: ModalService) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalService.close(this.modalName);
  }
}
